const key = {
  ENV_DEFAULT_KEY: process.env.PORTAL_ROOT_ENVIRONMENT || 'default_env',
  DEPLOY_PATH: 'portal_deploy_path',
};

const apis = {
  apisEndpoints: {
    default_env: {
      STATIC_CONFIG_URL_SERVER: 'https://static.delfi.lt/portal-configuration',
      STATIC_CONFIG_URL: 'https://static.delfi.lt/portal-configuration',
      FEED_API_URL_SERVER: 'https://www.delfi.lt/misc/pc/feed.php',
      FEED_API_URL: 'https://www.delfi.lt/misc/pc/feed.php',
      COMMENT_FE_URL: 'https://lt-production-comment-fe.s3.delfi.lt/loader.js',
      CONTENT_API_URL_V3: 'https://content.api.delfi.lt/content/v3',
      CONTENT_API_URL_V3_SERVER: 'https://content.api.delfi.lt/content/v3',
      MEDIA_API_URL_SERVER: 'https://images.delfi.lt/media-api-image-cropper/v1',
      MEDIA_API_URL: 'https://images.delfi.lt/media-api-image-cropper/v1',
      MEDIA_API_DATA_URL_SERVER: 'https://media.api.delfi.lt/media/v1',
      MEDIA_API_DATA_URL: 'https://media.api.delfi.lt/media/v1',
      CUSTOMER_DATA_API_URL: 'https://customer.api.delfi.lt/customer-data/v2',
      WEATHER_API_URL_SERVER: 'https://lt-weather.api.delfi.lt/weather/v1/graphql',
      WEATHER_API_URL: 'https://lt-weather.api.delfi.lt/weather/v1/graphql',
      CDN_PUBLIC_PATH: 'https://lt-production-portal-root.s3.delfi.lt',
    },
    lt_test: {
      STATIC_CONFIG_URL_SERVER: 'https://static.delfi.lt/portal-configuration/test',
      STATIC_CONFIG_URL: 'https://static.delfi.lt/portal-configuration/test',
      FEED_API_URL_SERVER: 'https://www.delfi.lt/misc/pc/feed.php',
      FEED_API_URL: 'https://www.delfi.lt/misc/pc/feed.php',
      COMMENT_FE_URL: 'https://lt-review-comment-fe.s3.test.delfi.lt/master/loader.js',
      CONTENT_API_URL_V3: 'https://content.api.test.delfi.lt/content/v3',
      CONTENT_API_URL_V3_SERVER: 'http://lt-test-content-api-v3-auto-deploy.content-api-v3/content/v3',
      MEDIA_API_URL_SERVER: 'https://images.delfi.lt/media-api-image-cropper/v1',
      MEDIA_API_URL: 'https://images.delfi.lt/media-api-image-cropper/v1',
      MEDIA_API_DATA_URL_SERVER: 'https://media.api.delfi.lt/media/v1',
      MEDIA_API_DATA_URL: 'https://media.api.delfi.lt/media/v1',
      CUSTOMER_DATA_API_URL: 'https://api.test.delfi.lt/customer-data/v2',
      WEATHER_API_URL_SERVER: 'http://lt-test-lt-weather-api-auto-deploy.lt-weather-api/weather/v1/graphql',
      WEATHER_API_URL: 'https://lt-weather.api.test.delfi.lt/weather/v1/graphql',
      CDN_PUBLIC_PATH: process.env.CDN_PUBLIC_PATH || 'https://lt-test-portal-root.s3.test.delfi.lt',
    },
    lt_review: {
      STATIC_CONFIG_URL_SERVER: 'https://static.delfi.lt/portal-configuration',
      STATIC_CONFIG_URL: 'https://static.delfi.lt/portal-configuration',
      FEED_API_URL_SERVER: 'https://www.delfi.lt/misc/pc/feed.php',
      FEED_API_URL: 'https://www.delfi.lt/misc/pc/feed.php',
      COMMENT_FE_URL: 'https://lt-production-comment-fe.s3.delfi.lt/loader.js',
      CONTENT_API_URL_V3: 'https://content.api.delfi.lt/content/v3',
      CONTENT_API_URL_V3_SERVER: 'http://lt-production-content-api-v3-auto-deploy.content-api-v3/content/v3',
      MEDIA_API_URL_SERVER: 'https://images.delfi.lt/media-api-image-cropper/v1',
      MEDIA_API_URL: 'https://images.delfi.lt/media-api-image-cropper/v1',
      MEDIA_API_DATA_URL_SERVER: 'https://media.api.delfi.lt/media/v1',
      MEDIA_API_DATA_URL: 'https://media.api.delfi.lt/media/v1',
      CUSTOMER_DATA_API_URL: 'https://customer.api.delfi.lt/customer-data/v2',
      WEATHER_API_URL_SERVER: 'http://lt-test-lt-weather-api-auto-deploy.lt-weather-api/weather/v1/graphql',
      WEATHER_API_URL: 'https://lt-weather.api.delfi.lt/weather/v1/graphql',
      CDN_PUBLIC_PATH: process.env.CDN_PUBLIC_PATH || `https://lt-review-portal-root.s3.review.delfi.lt/${key.DEPLOY_PATH}`,
    },
    lt_production: {
      STATIC_CONFIG_URL_SERVER: 'https://static.delfi.lt/portal-configuration',
      STATIC_CONFIG_URL: 'https://static.delfi.lt/portal-configuration',
      FEED_API_URL_SERVER: 'https://www.delfi.lt/misc/pc/feed.php',
      FEED_API_URL: 'https://www.delfi.lt/misc/pc/feed.php',
      COMMENT_FE_URL: 'https://lt-production-comment-fe.s3.delfi.lt/loader.js',
      CONTENT_API_URL_V3: 'https://content.api.delfi.lt/content/v3',
      CONTENT_API_URL_V3_SERVER: 'http://lt-production-content-api-v3-auto-deploy.content-api-v3/content/v3',
      MEDIA_API_URL_SERVER: 'https://images.delfi.lt/media-api-image-cropper/v1',
      MEDIA_API_URL: 'https://images.delfi.lt/media-api-image-cropper/v1',
      MEDIA_API_DATA_URL_SERVER: 'http://lt-production-media-api-auto-deploy.media-api/media/v1',
      MEDIA_API_DATA_URL: 'https://media.api.delfi.lt/media/v1',
      CUSTOMER_DATA_API_URL: 'https://customer.api.delfi.lt/customer-data/v2',
      WEATHER_API_URL_SERVER: 'http://lt-production-lt-weather-api-auto-deploy.lt-weather-api/weather/v1/graphql',
      WEATHER_API_URL: 'https://lt-weather.api.delfi.lt/weather/v1/graphql',
      CDN_PUBLIC_PATH: process.env.CDN_PUBLIC_PATH || 'https://lt-production-portal-root.s3.delfi.lt',
    },
  },
};

const channelEnv = key.ENV_DEFAULT_KEY as keyof typeof apis.apisEndpoints;
const DEFAULT_CLIENT_CONFIG = apis.apisEndpoints[channelEnv];

export default DEFAULT_CLIENT_CONFIG;
